import { message } from 'antd';
import _, { get } from 'lodash';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(customParseFormat);
dayjs.extend(isBetween);

export {
  ABOUT_ITEMS,
  ACTIVE_INACTIVE_STATUS_FILTER_LIST,
  CUSTOMER_CSV_REQUIRED_FIELD,
  DATE_FORMAT,
  ORDER_STATUS_FILTER_LIST,
  WITHDRAWAL_STATUS_FILTER_LIST,
} from './constants';

export const errHandling = (error) => {
  return message.error(
    get(
      error,
      'response.data.message',
      'Cannot connect to server, please check connection'
    )
  );
};

export const formatStatus = (value) => {
  if (value && value.includes('_')) return _.startCase(_.toLower(value));
  else if (value) return _.capitalize(value);
  else return '';
};

export const priceFormat = (price) => {
  if (price) {
    let modPrice = [];
    let [base_price, decimal] = price.toString().split('.');

    base_price = base_price.toString().split('').reverse();
    while (base_price.length > 3) {
      modPrice.push(base_price.splice(0, 3).reverse().join(''));
    }
    modPrice.push(base_price.reverse().join(''));
    if (!decimal || Number(decimal) === 0) {
      decimal = '.00';
    } else {
      decimal = '.' + decimal;
    }
    return modPrice.reverse().join(',') + decimal;
  } else return price;
};

export function convertNumberToRupiahCurrency(number) {
  if (number) {
    let rupiah = '';
    let numberRev = parseInt(number).toString().split('').reverse().join('');
    for (let i = 0; i < numberRev.length; i++) {
      if (i % 3 === 0) rupiah += numberRev.substr(i, 3) + '.';
    }

    return (
      'IDR ' +
      rupiah
        .split('', rupiah.length - 1)
        .reverse()
        .join('')
    );
  } else if (number === 0) {
    return 'IDR 0';
  }
}

export function convertNumberToNumberRupiahCurrency(number) {
  if (number) {
    let rupiah = '';
    let numberRev = parseInt(number).toString().split('').reverse().join('');
    for (let i = 0; i < numberRev.length; i++) {
      if (i % 3 === 0) rupiah += numberRev.substr(i, 3) + '.';
    }

    return rupiah
      .split('', rupiah.length - 1)
      .reverse()
      .join('');
  } else if (number === 0) {
    return '0';
  }
}

export function isNil(key) {
  return key === undefined || key === null || key === '';
}

export async function copyTextToClipboard(text) {
  if ('clipboard' in navigator) {
    return await navigator.clipboard.writeText(text);
  }
  return document.execCommand('copy', true, text);
}

export function formatDate(date, dateFormat = 'DD/MM/YYYY') {
  return dayjs(date).format(dateFormat);
}

export const generateArrayWithBaseObject = (baseObject, length) =>
  new Array(length).fill(null).map(() => ({ ...baseObject }));
